module.exports = __webpack_public_path__ + "static/img/zsk1.9a8a0be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zsk1.png
// module id = SOvU
// module chunks = 78